import * as Yup from 'yup';
import {
    stringWithNoSpecialChars,
    validatePropertyType,
    validateDate,
    validateNumericId,
    validatePropertyCategory,
    validatePropertyCondition,
    validatePropertyStanding,
    validateAvailability,
    validateMediaType,
    validateOptionalUrl,
    validateOptionalNumber,
    validateOperationType,
    validateFileByType,
    validateFloat,
    validateAmountRangeType,
    validatePropertyUsageType,
    validateAmount
} from "@/Shared/Helpers";


import {  
    MediaURL, 
    PropertyEnums, 
    UPLOAD_ALLOWED_MEDIA_FILE_TYPES, 
    UPLOAD_MAX_FILES, 
    UPLOAD_MAX_MEDIA_SIZE, 
    UPLOAD_MAX_THUMB_SIZE, 
    UploadedMedia 
} from '@/Shared/Types';

export type PropertyFormValues = {
    //mandateId: number,
    furnished: boolean,
    availability: string,
    propertyType: string,
    propertyCategory: string,
    availableAt: string,
    condition: string,
    yearBuilt: number,

    // Address / Secteur
    sectorId: number,
    cityId: number,
    address: string,

    // Pièces
    roomCount: number,
    surfaceArea: number,
    amenityFeatures: string[] | null,
    serviceFeatures: string[] | null,
    owners : string[],
    standing: string,
    price: string,
    serviceChargeProvision: string,
    acMaintenanceCharge? : string;
    securityDeposit? : string;
    totalPrice: string,
    priceRange: string,
    operationType : string,

    // Autres
    description: string,
    images: UploadedMedia[],
    videos: MediaURL[],
    videoURLs : string[];

    usageType: string,
};

const mediaFileOptions = { 
    maxSizeInMB : UPLOAD_MAX_MEDIA_SIZE, 
    allowedTypes : UPLOAD_ALLOWED_MEDIA_FILE_TYPES 
};
const mediaThumbOptions = { 
    maxSizeInMB : UPLOAD_MAX_THUMB_SIZE, 
    allowedTypes : UPLOAD_ALLOWED_MEDIA_FILE_TYPES 
};

export const PropertyValidationSchema = (viewEnums: PropertyEnums) => Yup.object({

    usageType: validatePropertyUsageType(viewEnums.PropertyUsageEnum, true),

    propertyCategory: validatePropertyCategory(viewEnums.PropertyCategoryEnum),

    availability: validateAvailability(viewEnums.AvailabilityEnum),

    propertyType: validatePropertyType(viewEnums.PropertyTypeEnum),

    operationType : validateOperationType(viewEnums.OperationTypeEnum),

    condition: validatePropertyCondition(viewEnums.PropertyConditionEnum),

    standing: validatePropertyStanding(viewEnums.StandingEnum),

    availableAt: validateDate().notRequired(),

    yearBuilt: validateOptionalNumber(),

    sectorId: validateNumericId().required('Le secteur du bien est requis.'),

    cityId: validateNumericId().required('La ville du bien est requise.'),

    roomCount: validateOptionalNumber(),

    surfaceArea: validateOptionalNumber(),

    price: validateAmount().required('Le prix du bien est requis.'),

    serviceChargeProvision: validateAmount().notRequired(),

    acMaintenanceCharge : validateAmount().nullable().notRequired(),

    securityDeposit : validateAmount().nullable().notRequired(),

    totalPrice: validateAmount().notRequired(),

    priceRange : validateAmountRangeType(viewEnums.PriceRangeEnum),
    
    address: stringWithNoSpecialChars({ maxLength: 100 }).required('L\'adresse du bien est requise.'),

    description: stringWithNoSpecialChars({ minLength: 10, maxLength: 500 })
    .transform((value, originalValue) =>  originalValue === '' ? null : value).nullable().notRequired(),

    
    images: Yup.array().of(
        Yup.object({
            id : validateOptionalNumber(),
            large: validateFileByType(mediaFileOptions),
            small: validateFileByType(mediaThumbOptions),
            type : validateMediaType('image'),
            caption: stringWithNoSpecialChars({ minLength: 5, maxLength: 255 }).notRequired().nonNullable(),
        })
    ).max(UPLOAD_MAX_FILES, `Maximum de ${UPLOAD_MAX_FILES} images`)
    .notRequired()
    .nonNullable(),

    videos: Yup.array().of(
        Yup.object({
            id : validateOptionalNumber(),
            url: validateOptionalUrl(),
            small: validateFileByType(mediaThumbOptions),
            type : validateMediaType('video'),
            caption: stringWithNoSpecialChars({ minLength: 5, maxLength: 255 }).notRequired().nonNullable(),
        })
    ).max(UPLOAD_MAX_FILES, `Maximum de ${UPLOAD_MAX_FILES} images`)
    .notRequired()
    .nonNullable(),
});
